import React from 'react'
import { Link } from 'gatsby'
import {
  Header,
  Layout,
  SectionTitle,
  ItemTitle,
  Intro,
} from '../../../../components'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        state="design"
        exclusive={true}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        title={data.title}
        state="design"
      >
        <Intro>
          <p>
            Shadow styles create the perception of{' '}
            <Link
              to={'/' + data.site + '/guidelines/elevation/design'}
              class="link"
            >
              elevation
            </Link>{' '}
            along the z-axis to communicate hierarchy and organize information
            within a design.
          </p>
        </Intro>

        <SectionTitle>Shadow Variants</SectionTitle>

        <ItemTitle>Small</ItemTitle>
        <p>
          Use to position an object a small distance above the pane or level
          behind it. Artificially elevated objects, as well as elevated objects
          on the interaction level will use this style.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <thead>
            <th> </th>
            <th>Key</th>
            <th>Ambient</th>
            <th>Usage</th>
          </thead>
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-small--down"></span>
                  Small / Down
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 1</strong>
                <br />
                blur: <strong>2</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 2</strong>
                <br />
                blur: <strong>4</strong>
              </td>
              <td class="showcase-table__usage">
                For small distances on a mid-screen or top-aligned object
              </td>
            </tr>
            <tr class="showcase-table__grey-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-small--up"></span>
                  Small / Up
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -1</strong>
                <br />
                blur: <strong>2</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -2</strong>
                <br />
                blur: <strong>4</strong>
              </td>
              <td class="showcase-table__usage">
                For small distances on a bottom-aligned object
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>Medium</ItemTitle>
        <p>
          Use to position an object a medium distance above the pane or level
          behind it. Elevated objects on the frame level will use this style.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-medium--down"></span>
                  Medium / Down
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 2</strong>
                <br />
                blur: <strong>4</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 4</strong>
                <br />
                blur: <strong>8</strong>
              </td>
              <td class="showcase-table__usage">
                For medium distances on a mid-screen or top-aligned object
              </td>
            </tr>
            <tr class="showcase-table__grey-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-medium--up"></span>
                  Medium / Up
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -2</strong>
                <br />
                blur: <strong>4</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -4</strong>
                <br />
                blur: <strong>8</strong>
              </td>
              <td class="showcase-table__usage">
                For medium distances on a bottom-aligned object
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Large</ItemTitle>
        <p>
          Use to position an object a large distance above the pane or level
          behind it. Elevated objects on the attention pane will use this style.
        </p>
        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-large--down"></span>
                  Large / Down
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 3</strong>
                <br />
                blur: <strong>6</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 6</strong>
                <br />
                blur: <strong>12</strong>
              </td>
              <td class="showcase-table__usage">
                For large distances on a mid-screen or top-aligned object
              </td>
            </tr>
            <tr class="showcase-table__grey-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-large--up"></span>
                  Large / Up
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -3</strong>
                <br />
                blur: <strong>6</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -6</strong>
                <br />
                blur: <strong>12</strong>
              </td>
              <td class="showcase-table__usage">
                For large distances on a bottom-aligned object
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>Extra Large</ItemTitle>
        <p>
          Use to position an object a large distance above the pane or level
          behind it. Elevated objects on the attention pane will use this style.
        </p>

        <table class="showcase-table l-margin-bottom--none">
          <tbody>
            <tr class="showcase-table__white-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-xlarge--down"></span>
                  Extra Large / Down
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 4</strong>
                <br />
                blur: <strong>8</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, 8</strong>
                <br />
                blur: <strong>16</strong>
              </td>
              <td class="showcase-table__usage">
                For large distances on a mid-screen or top-aligned object
              </td>
            </tr>
            <tr class="showcase-table__grey-row">
              <td>
                <div class="u-flex-container u-flex-align--middle">
                  <span class="table__box u-shadow-xlarge--up"></span>
                  Extra Large / Up
                </div>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -4</strong>
                <br />
                blur: <strong>8</strong>
              </td>
              <td class="showcase-table__font-values">
                color: <strong>#000</strong>
                <br />
                x, y: <strong>0, -8</strong>
                <br />
                blur: <strong>16</strong>
              </td>
              <td class="showcase-table__usage">
                For large distances on a bottom-aligned object
              </td>
            </tr>
          </tbody>
        </table>
        <ItemTitle>None</ItemTitle>
        <p>
          Use when an object is embedded within a given pane or level and not
          elevated above it. All objects in the foundational pane will use this
          style.
        </p>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Consult the{' '}
          <Link
            to={'/' + data.site + '/guidelines/elevation/design'}
            class="link"
          >
            elevation
          </Link>{' '}
          guidelines to select the appropriate shadow size for an object, based
          on its position along the z-axis. Only apply shadows in the up
          direction when the down direction would be lost along the bottom edge
          of the screen or parent element.
        </p>
      </Layout>
    </>
  )
}
